import {customElement, bindable} from "aurelia-framework";
import {AbstractCell} from './abstract-cell';

@customElement('sio-cell-hash')
export class Hash extends AbstractCell {
    @bindable column;
    @bindable item;

    itemChanged() {
        this.bind();
    }
}
